import React from 'react';
import { improvementOpportunity } from '../../../../utility/common';
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

interface typeCRKeywordOpportunity {
  pageSource: string;
  monthly_clicks: number;
  paid_clicks: number;
  monthly_impressions: number;
  paid_impressions: number;
}

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#F8E2A0',
    color: '#212121 !important',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    height: 'auto',
    fontWeight: 600,
    lineHeight: '16px',
  },
}))(Tooltip);

const CRKeywordOpportunity: React.FunctionComponent<typeCRKeywordOpportunity> = ({
  pageSource,
  monthly_clicks,
  paid_clicks,
  monthly_impressions,
  paid_impressions,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const improvementOpportunityData: any = improvementOpportunity(
    pageSource,
    monthly_clicks,
    paid_clicks,
    monthly_impressions,
    paid_impressions
  );
  return improvementOpportunityData?.improvementText ? (
    <div data-testid="crkeyword-opportunity-wrapper-test">
      <LightTooltip title={improvementOpportunityData?.improvementInfo}>
        <p className="m-0 unset-margin" data-testid="crkeyword-opportunity-p-wrapper-test">
          <span
            className="cr-keyword-status-badge badge-white-space"
            data-testid="crkeyword-opportunity-span-wrapper-test"
          >
            {improvementOpportunityData?.improvementText}
          </span>
        </p>
      </LightTooltip>
    </div>
  ) : null;
};

export default React.memo(CRKeywordOpportunity);
